import React from "react";
import { NavLink } from "react-router-dom";

import styles from "./styles";
import useGlobal from "../../store";
import * as Config from "../../helper/Configs";

export default function Logo() {
	const classes = styles();
	const [globalState, globalActions] = useGlobal();
	const { contactUs } = globalState.cmsContext;

	return (
        <div className={classes.logoouter}>
            <span>
                <NavLink to="/">
                    <img src={`${Config.MEDIA_URL}images/${contactUs.logo}`} />
                </NavLink>
            </span>
        </div>
	);
}
